import SortImg from "assets/icons/sort.svg";
import { Pagination } from "components/Pagination";
import "./style.scss";

type Props = {
  data: any[];
};

export const CustomerRewardTable: React.FC<Props> = ({ data }) => {
  return (
    <>
      <section className="table-component">
        <table className="table-component_table">
          <thead>
            <tr className="table-component_head">
              <th
                className="table-component_table-th"
                style={{ width: "16%" }}
                scope="col"
              >
                <div>
                  <span>Account No.</span>
                  <img
                    src={SortImg}
                    alt="sort"
                    className="table-component_table-th-sort"
                  />
                </div>
              </th>
              <th
                className="table-component_table-th"
                style={{ width: "13%" }}
                scope="col"
              >
                <div>
                  <span>Open Date.</span>
                  <img
                    src={SortImg}
                    alt="sort"
                    className="table-component_table-th-sort"
                  />
                </div>
              </th>
              <th
                className="table-component_table-th"
                style={{ width: "12%" }}
                scope="col"
              >
                <div>
                  <span>Tier Status.</span>
                  <img
                    src={SortImg}
                    alt="sort"
                    className="table-component_table-th-sort"
                  />
                </div>
              </th>
              <th
                className="table-component_table-th"
                style={{ width: "15%" }}
                scope="col"
              >
                <div>
                  <span>Card Status.</span>
                  <img
                    src={SortImg}
                    alt="sort"
                    className="table-component_table-th-sort"
                  />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
          {data && data.length > 0 ? data.map((d?: any, index?: number) => (
            <tr key={index}>
              <td className="table-component_table-td">
                {d?.sourcesyfaccountlast4 ? `****${d?.sourcesyfaccountlast4}` : 'N/A'}
              </td>
              <td className="table-component_table-td">
                {d?.sourcesyfaccountopendate ? d?.sourcesyfaccountopendate : 'N/A'}
              </td>
              <td className="table-component_table-td">
                {d?.sourcesyftierstatus ? d?.sourcesyftierstatus : 'N/A'}
              </td>
              <td className="table-component_table-td">
                {d?.sourcesyfcardstatus ? (<span className="table-component_table-badge">{d?.sourcesyfcardstatus}</span>) : 'N/A'}
              </td>
            </tr>
          )) : (
            <tr>
              <td colSpan={4} style={{textAlign: 'center', padding: '15px 0'}}>No rewards available</td>
            </tr>
          )}
          </tbody>
        </table>
      </section>
      {data && data.length > 0 && (
        <Pagination
          pageIndex={1}
          pageCount={1}
          setCurrentPage={(val) => false}
        />
      )}
    </>
  );
};
